import { apiRequest } from './api';

/**
 * Deepgram için kısa ömürlü erişim anahtarı — TalkNote sunucusundan
 * (`/api/v1/transcription/token`). Ana anahtar masaüstünde yok.
 *
 * Anahtar yalnızca bağlantı/istek başında kontrol edildiği için ~60 sn
 * yetiyor. Mikrofon ve sistem sesi aynı anda bağlanınca tek istek paylaşılsın,
 * kalan süresi yeterliyse tekrar kullanılsın.
 */

/** Bu kadar süresi kalmayan anahtar yeniden kullanılmaz. */
const MIN_REMAINING_MS = 20_000;

/** Sunucu aylık kota dolduysa, onay eksikse ya da döküm durdurulduysa vermez (402/403/503). */
let cached: { token: string; expiresAt: number; sessionId: string | null } | null = null;
let pending: Promise<string> | null = null;

/**
 * `sessionId`: bu kaydın canlı oturumu (liveSessions.ensureLiveSession). Sunucu
 * anahtarı yalnızca o oturum açıkken verir — aynı anda tek kayıt sınırı.
 */
export async function deepgramAccessToken(sessionId: string | null = null): Promise<string> {
  if (cached && cached.sessionId === sessionId && cached.expiresAt - Date.now() > MIN_REMAINING_MS) return cached.token;

  if (!pending) {
    pending = apiRequest<{ accessToken: string; expiresIn: number }>('POST', '/api/v1/transcription/token', {
      body: sessionId ? { sessionId } : {},
      timeoutMs: 15_000,
    })
      .then(({ accessToken, expiresIn }) => {
        cached = { token: accessToken, expiresAt: Date.now() + expiresIn * 1000, sessionId };
        return accessToken;
      })
      .finally(() => {
        pending = null;
      });
  }
  return pending;
}

/** Anahtar reddedildiyse (401) önbelleği boşalt — sonraki deneme yenisini alsın. */
export function forgetDeepgramToken(): void {
  cached = null;
}
